import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearLFStorage, LFStorageKeys } from '../../../services/storage/LFStorage';
import { useDispatch, useSelector } from 'react-redux';
import { ProgressBar } from '../../ui/Loader/progressBar';
import { getAuthData } from '../../../services/storage/LocalStorage';
import { logoutUser } from '../../../state/actions/user';
import { MenuIcon } from './menuIcon';
import { Badge, styled } from '@mui/material';
import { RechargeContext } from '../../../RechargeContext.js';
import { setDomainState } from '../../../state/actions/domain.js';
import { toggleConversationFavouriteStatus } from '../../../state/actions/chats.js';
import { useSocket } from '../../../services/socket/socketContext.js';
import { fetchContacts } from '../../../state/actions/contacts.js';

import AddNewContact from '../../ui/AddNewContact.js'
import UserProfile from './userProfile.js';
import PendingRequestPopup from '../../../pages/ContactsView/PendingRequest/PendingRequestPopup.js';
import ModalNewUI from '../../ui/Modals/ModalMessages/ModalNewUI.js';
import DiallerPadButton from '../../../pages/Telephony/Dialler/DiallerPadButton.js';
import DiallerButton from '../../../pages/Telephony/Dialler/DiallerButton.js';
import AddNewContactFunctional from '../../../pages/ContactsView/AddNewContact/AddNewContactFunctional.js';
import Banner from '../../common/Banner/index.js';
import NotificationBell from '../../ui/NotificationBell.js'
import { fullBotScriptReset } from '../../../utils/ChatbotScriptHelpers/index.js';
import { deRegisterPushNotification, getPageName } from '../../../utils/general.js';
import MarketplaceSearch from './Marketplace/search.js';
import { setClearCacheForSpinnetBot } from '../../../state/actions/bot.js';
import { disconnectWebSocket } from '../../../services/socket/initWebSocket.js';
import { getSocketConnection } from '../../../state/actions/socket.js';


const Header = () => {
    const [currentBotName, setCurrentBotName] = useState("");
    const [showFavoritesIcon, setShowFavoritesIcon] = useState(true);
    const [isFavoriteBot, setIsFavoriteBot] = useState(false);
    const botWaitLoader = useSelector((state) => state.loader?.botWaitLoader);
    const botWaitLoaderWithShimmerOnly = useSelector((state) => state.loader?.botWaitLoaderWithShimmerOnly);
    const allProfileImages = useSelector((state) => state.profileImages);
    const botSubscriptions = useSelector((state) => state.user?.botSubscriptions);
    const { selectedBotDetails, selectedDomainDetails, domains } = useSelector((state) => state.domain);
    const { selectedConversation, favourites } = useSelector((state) => state.chats);
    const headerTitle = useSelector((state) => state.layout.headerTitle);
    const allContacts = useSelector((state) => state?.contacts?.allContacts);
    const totalConnections = allContacts.reduce((sum, item) => sum + item.count, 0);

    const [addContactMenu, setAddContactMenu] = useState(false);
    const [showPendingRequest, setShowPendingRequest] = useState(false);
    const [showBadge, setShowBadge] = useState(false);
    const pendingContacts = useSelector((state) => state.contacts.pendingContacts);
    const showAddContact = () => setAddContactMenu(true);
    const closeAddContact = () => setAddContactMenu(false);
    const closePendingRequest = () => setShowPendingRequest(false);
    const isAnonymousUser = useSelector((state) => state.user.isAnonymousUser);
    const isUserOnline = useSelector((state) => state.user.isOnline);
    const selectedDomain = useSelector((state) => state.domain.selectedDomain)
    const reduxState = useSelector(state => state.user)
    const { openRecharge } = useContext(RechargeContext);
    const isDefaultHomePageBot = useSelector((state) => state.bot.isDefaultHomePageBot);

    const { disconnectSocket } = useSocket();

    //Assistant bot
    const isAssistantBotOpen = useSelector((state) => state.bot.isAssistantBotOpen);
    const user = getAuthData()?.user || null;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = getPageName();

    const voipMode =
        selectedDomainDetails &&
        selectedDomainDetails.viewModes &&
        selectedDomainDetails.viewModes?.voip;

    let pstnMode =
        selectedDomainDetails &&
            selectedDomainDetails?.viewModes &&
            !Object.prototype.hasOwnProperty.call(selectedDomainDetails.viewModes, "pstn")
            ? true
            : selectedDomainDetails?.viewModes?.pstn;

    useEffect(() => {
        if (botSubscriptions?.length > 0 && selectedBotDetails) {
            getCurrentBotName()
        }
    }, [botSubscriptions, selectedBotDetails, favourites]);

    const StyledBadge = styled(Badge)(() => ({
        "& .MuiBadge-badge": {
            backgroundColor: "#F74646",
        },
    }));

    useEffect(() => {
        // if (pendingContacts?.length) {
        // Here we check if there are any pending requests or not for this user. Based on that we show the badge.
        let isWaitingForConfirmation = !!pendingContacts?.find((x) => (x?.showAcceptIgnoreMsg === true));
        setShowBadge(isWaitingForConfirmation);
        // }
    }, [pendingContacts]);

    useEffect(() => {
        // Show favourite icon in header based on pathname
        if (location.pathname === "/app/chats" && selectedBotDetails && !isDefaultHomePageBot) {
            setShowFavoritesIcon(true);
        } else {
            setShowFavoritesIcon(false);
        }

    }, [location.pathname, isDefaultHomePageBot, selectedBotDetails]);

    const checkIsFavoriteBot = () => {
        const favouriteBot = favourites?.find((list) => list.bot.botId === selectedBotDetails?.botId);
        setIsFavoriteBot(favouriteBot? true : false);
    }


    const getCurrentBotName = () => {
        if (location.pathname === "/app/chats") {
            const landingBot = domains?.filter((item) => item.lastLoggedIn)
            const botParams = landingBot?.[0]?.landingBotId || ''
            const currentBot = botSubscriptions?.find(bot => botParams == bot?.botId);
            setCurrentBotName(selectedBotDetails?.botName ? selectedBotDetails?.botName : currentBot?.botName);
            // we show favorites iocn only for installed bots

            if (!isDefaultHomePageBot) {
                setShowFavoritesIcon(true);
                checkIsFavoriteBot();
            }

        }
        else if (location.pathname === "/app/my-profile") {
            setCurrentBotName("My Profile")
        } else if (location.pathname === "/app/messages") {
            setCurrentBotName("Connect")
        }
    };

    const handleSetFavorite = () => {
        let isFavorite = favourites?.find((list) => list.bot.botId === selectedBotDetails?.botId);
        // setIsFavoriteBot(isFavorite? false : true);
        dispatch(toggleConversationFavouriteStatus({
            conversationId: selectedConversation?.conversationId,
            userDomain: selectedDomainDetails?.userDomain,
            botId: selectedBotDetails?.botId,
            action: isFavoriteBot ? "remove" : "add"
        }));
    }


    const handleLogout = async (e) => {
        e.preventDefault();
        const userId = getAuthData()?.user?.userId || null;
        deRegisterPushNotification(selectedDomainDetails)
        if (userId) clearLFStorage();
        dispatch(setClearCacheForSpinnetBot(false));

        localStorage.removeItem("user");
        localStorage.removeItem("LoggedState");
        localStorage.removeItem("sessionId");
        localStorage.removeItem('scriptLoaded');
        localStorage.removeItem('connectionId');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('accessToken');
        localStorage.removeItem(LFStorageKeys.HEADER_TITLE)
        localStorage.removeItem(LFStorageKeys.SELECTED_BOT)
        localStorage.removeItem(LFStorageKeys.ACTIVE_ITEM)
        localStorage.removeItem(LFStorageKeys.SELECTED_DOMAIN)
        disconnectWebSocket();
        dispatch(getSocketConnection(false))
        dispatch(logoutUser());
        fullBotScriptReset(); //reset chatbot script
        navigate("/");
    };

    const showGetCreditModal = () => {
        if (openRecharge) {
            openRecharge();
        }
    };

    return (
        <>
            <header className="bg-header-bg z-20 sm:shadow-none shadow w-full px-4">
                <div className="flex items-center justify-between sm:flex-row sm:px-4 sm:py-2 py-2 px-2 w-full">
                    <div className=''>
                        <MenuIcon
                            isAssistantBotOpen={isAssistantBotOpen}
                            currentTabName={headerTitle}
                            currentBotName={headerTitle}
                            showFavoritesIcon={showFavoritesIcon}
                            isFavoriteBot={isFavoriteBot}
                            handleSetFavorite={handleSetFavorite}

                        />
                        {headerTitle == 'Contacts' &&
                            <h1 className="text-size-13">Your Connections ({totalConnections})</h1>}
                    </div>
                    <div className='flex items-center gap-3'>
                        {headerTitle == 'Contacts' &&
                            <>
                                <AddNewContact onClick={showAddContact} className="" />
                                <StyledBadge color="primary" invisible={!showBadge} overlap="circular" badgeContent="" variant="dot">
                                    <NotificationBell onClick={() => setShowPendingRequest(true)}></NotificationBell>
                                </StyledBadge></>
                        }
                    </div>
                    <div className="flex items-center md:gap-2 gap-1 mt-1">
                        {/* Right Section */}
                        {!isAnonymousUser && voipMode && pstnMode && (
                            <div
                                className="get-credits-intro flex text-xs justify-center items-center border border-[#D5D5FF] bg-[#F4F4FF]"
                                style={{
                                    borderRadius: "10px",
                                    marginRight: "10px",
                                    height: '36px'
                                }}
                            >
                                <div className={`${selectedDomain}_font py-[10px] ps-[25px] px-[10px] !text-size-14 !text-purple-300 font-semibold`} style={{ color: "#666666", marginRight: "5px" }}>
                                    Balance:
                                    <span className='text-size-14 font-bold !text-primary-blue pl-1 pr-1' >
                                        ${reduxState?.balance.toFixed(2)}
                                    </span>
                                </div>
                                <div
                                    className="flex bg-white h-full w-[36px] items-center justify-center rounded-tr-[10px] rounded-br-[10px] cursor-pointer"
                                    disabled={!isUserOnline}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        openRecharge()
                                    }}
                                >
                                    <svg width="40" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32.0005 0C35.8663 0.000253383 39.0005 3.13416 39.0005 7V33C39.0005 36.8658 35.8663 39.9997 32.0005 40H1.90479C1.3525 40 0.904785 39.5523 0.904785 39V0.999999C0.904785 0.447714 1.3525 0 1.90479 0H32.0005ZM19.9526 12.1738C19.1187 12.1738 18.4421 12.8852 18.4419 13.7627V17.4277C18.4419 17.98 17.9942 18.4277 17.4419 18.4277H14.0093C13.1754 18.4277 12.4988 19.1392 12.4985 20.0166C12.4985 20.8943 13.1752 21.6064 14.0093 21.6064H17.4419C17.9942 21.6064 18.4419 22.0542 18.4419 22.6064V26.2373C18.4421 27.1148 19.1187 27.8262 19.9526 27.8262C20.7865 27.826 21.4622 27.1147 21.4624 26.2373V22.6064C21.4624 22.0542 21.9101 21.6064 22.4624 21.6064H25.896C26.7299 21.6062 27.4058 20.8941 27.4058 20.0166C27.4055 19.1393 26.7297 18.4279 25.896 18.4277H22.4624C21.9101 18.4277 21.4624 17.98 21.4624 17.4277V13.7627C21.4622 12.8853 20.7865 12.174 19.9526 12.1738Z" fill="#15194B" />
                                    </svg>
                                </div>
                                {/* Right Section */}
                            </div>)}
                        <div className='flex items-center gap-4 mr-3'>
                            {voipMode && (
                                <DiallerButton
                                    noBalance={() => {
                                        showGetCreditModal();
                                    }}
                                    selectedDomain={selectedDomainDetails}
                                />)}
                            {voipMode && pstnMode && (
                                <DiallerPadButton
                                    user={user}
                                    noBalance={() => {
                                        showGetCreditModal();
                                    }}
                                />
                            )}

                        </div>
                        {["Catalog_Featured", "Catalog_Categories", "Catalog"].includes(pathname) && (
                            <div className="mr-3">
                                <MarketplaceSearch />
                            </div>
                        )}
                        <UserProfile handleLogout={handleLogout} />
                    </div>
                    {addContactMenu && (
                        <ModalNewUI
                            onClose={closeAddContact}
                            headerContent={"Add new contact"}
                            open={addContactMenu}
                            customDialogStyles={{ width: '1050px', maxWidth: '1200px', height: '600px', maxHeight: '700px', overflowY: 'hidden' }}
                        >
                            <AddNewContactFunctional
                                cancel={closeAddContact}
                                selectedDomain={selectedDomainDetails}
                                fetchContacts={(data) => {
                                    if (data.selectedDomain) {
                                        dispatch(fetchContacts(data, true))
                                    }
                                }}
                            />
                        </ModalNewUI>
                    )}

                    {showPendingRequest && (
                        <ModalNewUI
                            open={showPendingRequest}
                            onClose={closePendingRequest}
                            className="notificationModal"
                            customDialogStyles={{ width: '1050px', maxWidth: '1200px', maxHeight: '700px', overflowY: 'hidden' }}
                            custompadding={"30px"}
                        >
                            <PendingRequestPopup
                                allProfileImages={allProfileImages}
                            />
                        </ModalNewUI>
                    )}
                </div>
                <Banner />
            </header>
            {(botWaitLoader || botWaitLoaderWithShimmerOnly) && <ProgressBar />}
        </>
    );
};

export default Header;